import React, { useState } from 'react'

import { Moment } from 'moment'

import { getPlansAndSeatsReport } from 'core'
import { now } from 'core/application/commons/dateUtils'

import Button from 'common/components/general/Button'

import { Col, Row } from 'common/components'
import { Card } from 'common/components'

import DatePicker from '../../../common/components/dataEntry/components/DatePicker'
import { downloadExcel } from '../../../common/downloadFile'
import { useQueryRequestV2 } from '../../../common/hooks'

interface PlansAndSeatsReportProps {
  name: string
}

const PlansAndSeatsReportSection = ({ name }: PlansAndSeatsReportProps) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [date, setDate] = useState<string>(null)

  const { isLoading, sendQuery } = useQueryRequestV2()

  const handleDateChange = (date: Moment | null, dateString: string) => {
    setDate(dateString)
  }
  const handleSubmit = async () => {
    setLoading(true)
    const result = await sendQuery(() => getPlansAndSeatsReport({ dateOfWeek: date, isLastReport: false }))
    if (result) {
      if (result) {
        downloadExcel(result, `customers_${date}.xlsx`)
      }
    }
    setLoading(false)
  }

  const handleDownloadLatest = async () => {
    setLoading(true)
    const result = await sendQuery(() => getPlansAndSeatsReport({ dateOfWeek: null, isLastReport: true }))
    if (result) {
      if (result) {
        downloadExcel(result, `customers_latest.xlsx`)
      }
    }
    setLoading(false)
  }

  return (
    <Card title={name}>
      <Row>
        <Col span={16}>
          <Row className="mt-16">
            <Col span={8}>
              <DatePicker
                placeholder="Select Week"
                className="w-100"
                format={'MM/DD/YYYY'}
                picker="week"
                onChange={handleDateChange}
                allowClear={false}
                disabledDate={(d) => !d || d.isAfter(now()) || d.isBefore('2023/08/07') || d.day() !== 1}
              ></DatePicker>
            </Col>
          </Row>
          <Row className="mt-16">
            <Col span={8}>
              <Button type="primary" disabled={!date} loading={loading} onClick={handleSubmit}>
                Download Report
              </Button>
            </Col>
          </Row>
        </Col>
        <Col span={8}>
          <Row className="mt-16 center">
            <Col span={8}>
              <Button type="primary" loading={loading} onClick={handleDownloadLatest}>
                Download Latest Requested
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  )
}

export default PlansAndSeatsReportSection
